import { createAsyncThunk } from '@reduxjs/toolkit';

import api, { PaymentPayload } from 'api';

export const getPaymentSystemURL = createAsyncThunk(
    'api/stripe/get-url',
    async (payment: PaymentPayload) => await api.payments.post(payment)
);
